export class MemSerializer {
    localForageSerializer;
    constructor(localForageSerializer) {
        this.localForageSerializer = localForageSerializer;
        void this.localForageSerializer;
    }
    serialize(value, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Don't emit warning.
    callback) {
        try {
            return Promise.resolve(callback(value, undefined));
        }
        catch (err) {
            return Promise.resolve(callback(null, err));
        }
    }
    deserialize(value) {
        return Promise.resolve(value);
    }
}
